var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
import { isAccepted, pollJob } from './jobs';
import { newProgressId } from './progress';
// Admin publishing flow for approved levels: generate/review/approve translations
// and read the combined publish-readiness (images + translations).
export function getTranslations(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/translations`);
    });
}
export function getPublishStatus(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/publish-status`);
    });
}
export function generateTranslations(levelId, progressId) {
    return __awaiter(this, void 0, void 0, function* () {
        // Translating every string into all target languages runs for minutes — far past
        // any proxy's patience (production's Cloudflare cuts the origin request at ~100 s
        // with a 524). The server answers 202 and runs the job detached; we collect the
        // result from the progress registry that already drives the bar.
        const id = progressId !== null && progressId !== void 0 ? progressId : newProgressId();
        const accepted = yield client.post(`/levels/${levelId}/translations/generate`, { progressId: id }, { timeout: 300000 });
        if (!isAccepted(accepted))
            return accepted; // older server: already the doc
        return pollJob(id, 'The translation status was lost — the server may have restarted. Reopen this dialog to see what was saved.');
    });
}
export function approveLanguage(levelId, lang) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/levels/${levelId}/translations/${lang}/approve`);
    });
}
export function unapproveLanguage(levelId, lang) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/levels/${levelId}/translations/${lang}/unapprove`);
    });
}
